import { sortRangesByStart } from "../../../../SuperAdmin/CreateApplication/ScoringScale/Utils";

export const GetBeforeAndAfterHitRanges = (ranges) => {
  //Returns the array of items that are before the hit item.
  // Sort ranges first to ensure correct order
  const sortedRanges = sortRangesByStart(ranges);

  let isAfterHitItem = false;

  let splitRanges = {
    hitRange: {},
    beforeHitRangeList: [],
    afterHitRangeList: [],
  };

  for (const range of sortedRanges) {
    if (range.isHit === true) {
      splitRanges.hitRange = range;
      isAfterHitItem = true;
    } else {
      if (isAfterHitItem) {
        splitRanges.afterHitRangeList.push(range);
      } else {
        splitRanges.beforeHitRangeList.push(range);
      }
    }
  }
  return splitRanges;
};
